import React from 'react';
import { createPortal } from 'react-dom';

export default function DeleteKPIDialog({ open, onClose, onConfirm }) {
  if (!open) return null;

  return createPortal(
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[9999] p-4">
      <div className="bg-white rounded-lg w-full max-w-md animate-modal">
        <div className="p-6">
          <h3 className="text-lg font-semibold mb-2">Hapus KPI?</h3>
          <p className="text-gray-500 text-sm">
            KPI ini akan dihapus secara permanen. Tindakan ini tidak dapat dibatalkan.
          </p>
        </div>
        <div className="flex justify-end gap-3 p-4 border-t bg-gray-50">
          <button
            onClick={onClose}
            className="px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-100 font-medium"
          >
            Batal
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 font-medium"
          >
            Hapus
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
